<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <DatosGeneralesForm
          :personal="personalEvaluado"
          :tipoEvaluacion.sync="editado.tipoEvaluacion"
          :fechaAplicacion.sync="editado.fecha"
          :idEvaluador.sync="editado.idPersonalEvaluador"
          editMode
        />
      </v-col>
      <v-col cols="12">
        <CumplimientoFuncionesForm
          v-for="rubro in rubrosWithObjetivos"
          :key="rubro.id"
          :rubro="rubro"
          :reactivos.sync="editado.reactivos"
          :frecuencias="frecuencias"
          :tipoEvaluacion="editado.tipoEvaluacion"
        />
      </v-col>
      <div class="mt-4 d-flex justify-end align-baseline">
        <TextButton @click="saveEvaluacion"> Guardar evaluación </TextButton>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import DatosGeneralesForm from '@src/components/desarrollo_policial/evaluacion-anual/DatosGeneralesForm.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CumplimientoFuncionesForm from '@src/components/desarrollo_policial/evaluacion-anual/CumplimientoFuncionesForm.vue'
import GetRubros from '@src/modules/evaluacion-anual/application/GetRubros'
import GetFrecuencias from '@src/modules/evaluacion-anual/application/GetFrecuencias'
import RUBRO_OBJETIVO_EVACOM from '@src/modules/evaluacion-anual/domain/RUBRO_OBJETIVO_EVACOM'
import RUBRO_OBJETIVO_EVACOM_MANDOS from '@src/modules/evaluacion-anual/domain/RUBRO_OBJETIVO_EVACOM_MANDOS'
import EvaluacionAnualApiRepository from '@src/modules/evaluacion-anual/infrastructure/EvaluacionAnualApiRepository'
import TextButton from '@src/components/base/TextButton.vue'
import UpdateEvaluacionAnual from '@src/modules/evaluacion-anual/application/UpdateEvaluacionAnual'

export default {
  components: { DatosGeneralesForm, CumplimientoFuncionesForm, TextButton },

  props: {
    evaluacion: {
      type: Object,
      required: true,
    },

    idPersonal: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      editado: {
        idEvaluacionAnual: this.evaluacion.id,
        idPersonalEvaluado: this.idPersonal,
        idPersonalEvaluador: this.evaluacion.fk_idPersonalEvaluador,
        estatus: this.evaluacion.fk_idCatEstatusEvaluacion,
        fecha: this.evaluacion.fecha,
        tipoEvaluacion: this.evaluacion.fk_idCatTipoEvaluacion,
        reactivos: [],
      },
      reactivos: [],
      frecuencias: [],
      rubros: [],
    }
  },

  async mounted() {
    this.rubros = await new GetRubros(EvaluacionAnualApiRepository).execute()
    this.frecuencias = await new GetFrecuencias(EvaluacionAnualApiRepository).execute()
  },

  computed: {
    ...mapGetters('personal', { personalEvaluado: 'getPersonalSingle' }),

    rubrosWithObjetivos: function () {
      return this.rubros.map((rubro) => {
        const objetivo =
          this.tipoEvaluacion === 8 ? RUBRO_OBJETIVO_EVACOM[rubro.id] : RUBRO_OBJETIVO_EVACOM_MANDOS[rubro.id]

        return { ...rubro, objetivo: objetivo ?? 'N/A' }
      })
    },
  },

  watch: {
    evaluacion: {
      handler(val) {
        this.editado = {
          idEvaluacionAnual: val.id,
          idPersonalEvaluado: this.idPersonal,
          idPersonalEvaluador: val.fk_idPersonalEvaluador,
          estatus: val.fk_idCatEstatusEvaluacion,
          fecha: val.fecha,
          tipoEvaluacion: val.fk_idCatTipoEvaluacion,
          reactivos: this.mapReactivos(),
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    ...mapActions('dialog', ['closeDialog']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    mapReactivos() {
      return this.evaluacion.cumplimientoFunciones.map((reactivo) => ({
        id: reactivo.id,
        idDescripcionCriterio: reactivo.fk_idDescripcionCriterio,
        idRubro: reactivo.DescripcionCriterio?.fk_idCatCriterioEvaluacion,
        descripcion: reactivo.DescripcionCriterio?.CatDescripcion?.title ?? '',
        calificacion: Number(reactivo.calificacion),
        estatus: true,
      }))
    },

    async saveEvaluacion() {
      try {
        this.loading = true

        const usecase = new UpdateEvaluacionAnual(EvaluacionAnualApiRepository)
        await usecase.execute({
          idEvaluacionAnual: this.editado.idEvaluacionAnual,
          idPersonalEvaluado: this.editado.idPersonalEvaluado,
          idPersonalEvaluador: this.editado.idPersonalEvaluador,
          estatus: this.editado.estatus,
          fecha: this.editado.fecha,
          tipoEvaluacion: this.editado.tipoEvaluacion,
          reactivos: this.editado.reactivos,
        })

        this.SET_SNACKBAR_MESSAGE('Evaluación actualizada correctamente')
        this.closeDialog()
      } catch (error) {
        console.error('Error al actualizar evaluación:', error)
        this.SET_SNACKBAR_MESSAGE('No fue posible actualizar la evaluación. Intente nuevamente.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
